import { Card, Flex, Heading, Text } from "@radix-ui/themes";

interface Props {
  label: string;
  value: string;
  /** Small gray line under the value, e.g. why a CTR is "—". */
  hint?: string;
}

export default function StatTile({ label, value, hint }: Props) {
  return (
    <Card size="2">
      <Flex direction="column" gap="1">
        <Text size="2" color="gray">
          {label}
        </Text>
        <Heading size="7">{value}</Heading>
        {hint && (
          <Text size="1" color="gray">
            {hint}
          </Text>
        )}
      </Flex>
    </Card>
  );
}
